<template lang="pug">
  .app.column(:class='{ "block-scroll": isModalOpen }')
    krea-navbar(v-if='isKreaRoute')
    navbar(v-if='!isKreaRoute && !hideNavbar')
    notifications-drawer
    router-view.router
    footer-comp.m-top-auto(:overFooter='showOverFooter')
    loader(v-if='showFullPageLoader')
    contact-modal(v-if='showContactModal')
    success-modal(v-if='showSuccessModal')
    forgot-password-modal(v-if='showForgotPasswordModal')
    termsAndConditonsModal(v-if='showTermsAndConditionsModal')
    trial-invite-modal(v-if='showTrialInviteModal')
    active-account-modal(v-if='showActiveAccountModal')
    sent-invitations-modal(v-if='showSentInvitationsModal')
    onboarding(v-show='showOnboarding')
    notification-modal(v-if='showNotificationModal')
    custom-toast
</template>

<script>
import { mapState } from 'vuex'
import amplitude from 'amplitude-js'

import KreaNavbar from '@/components/Krea/Navbar'
import Navbar from '@/components/Navbar'
import FooterComp from '@/components/FooterComp'
import Loader from '@/components/Loader'

import ContactModal from '@/components/Modals/ContactModal'
import SuccessModal from '@/components/Modals/SuccessModal'
import ActiveAccountModal from '@/components/Modals/ActiveAccountModal'
import ForgotPasswordModal from '@/components/Modals/ForgotPasswordModal'
import TermsAndConditonsModal from '@/components/Modals/TermsAndConditonsModal'
import TrialInviteModal from '@/components/Trial/TrialInviteModal'
import SentInvitationsModal from '@/components/Trial/SentInvitationsModal'
import Onboarding from '@/components/Feed/Onboarding'
import NotificationsDrawer from '@/components/Notifications/NotificationsDrawer'
import NotificationModal from '@/components/Notifications/NotificationModal'
import CustomToast from '@/components/CustomToast'

export default {
  components: {
    CustomToast,
    NotificationsDrawer,
    NotificationModal,
    Navbar,
    KreaNavbar,
    FooterComp,
    Loader,
    ContactModal,
    SuccessModal,
    ForgotPasswordModal,
    TermsAndConditonsModal,
    TrialInviteModal,
    ActiveAccountModal,
    SentInvitationsModal,
    Onboarding
  },
  created() {
    amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_API_KEY)
  },
  watch: {
    isModalOpen() {
      if (this.isModalOpen) document.body.style.overflow = 'hidden'
      else document.body.style.overflow = 'auto'
    }
  },
  computed: {
    ...mapState({
      showFullPageLoader: state => state.behavior.fullPageLoader.show,
      showContactModal: state => state.behavior.contactModal.show,
      showSuccessModal: state => state.behavior.successModal.show,
      showForgotPasswordModal: state => state.behavior.forgotPasswordModal.show,
      showTermsAndConditionsModal: state => state.behavior.termsAndConditionsModal.show,
      showTrialInviteModal: state => state.behavior.trialInviteModal.show,
      showActiveAccountModal: state => state.behavior.activeAccountModal.show,
      showSentInvitationsModal: state => state.behavior.sentInvitationsModal.show,
      showOnboarding: state => state.behavior.onboarding.show,
      showNotificationModal: state => state.behavior.notificationModal.show,
      isModalOpen: state => state.behavior.isModalOpen
    }),
    hideNavbar() {
      return this.$route.meta.hideNavbar
    },
    showOverFooter() {
      return this.$route.meta.showOverFooter
    },
    isKreaRoute() {
      return this.$route.meta.isKrea
    }
  }
}
</script>

<style lang="scss">
@import './scss/application';
@import './scss/variables/sizes';

.app {
  min-height: 100vh;
}
.router {
  padding-top: $navbar-height;
}
.block-scroll {
  overflow: hidden;
}
</style>
